import { AccessType, createEnumOptions, RemotegateType } from '../..';
import { IOlt } from './olt.interface';

export interface IOltPermission extends IOlt {
  accessMode: AccessMode | null;
  isAllowed: boolean;
}

export enum AccessMode {
  collocation = 'collocation',
  remotegate = 'remotegate',
}

export const accessModeOptions = createEnumOptions<AccessMode>({
  [AccessMode.collocation]: { label: 'Kolokácia' },
  [AccessMode.remotegate]: { label: 'Remotegate' },
  _default: { label: '-' },
});

export const remoteGateAccessTypes = [AccessType.remoteBa, AccessType.remoteZa];

export const getAccessModeFromType = (type: AccessType) => {
  switch (type) {
    case AccessType.collocation:
      return AccessMode.collocation;
    case AccessType.remoteBa:
    case AccessType.remoteZa:
      return AccessMode.remotegate;
    default:
      return null;
  }
};

export const getAccessTypeFromMode = (
  mode: AccessMode,
  remotegateType?: RemotegateType,
) => {
  switch (mode) {
    case AccessMode.collocation:
      return AccessType.collocation;
    case AccessMode.remotegate:
      if (remotegateType === RemotegateType.BA) {
        return AccessType.remoteBa;
      } else if (remotegateType === RemotegateType.ZA) {
        return AccessType.remoteZa;
      }
      return null;
    default:
      return null;
  }
};
